"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import type { HomePackage, PopularPackageSection } from "@/lib/navigation";
import PackageCard from "@/app/(main)/components/PackageCard";

import "swiper/css";

const DEFAULT_SUB_TITLE = "Best Place For You";
const DEFAULT_TITLE = "Most Popular Packages";

interface TourSliderProps {
  packages: HomePackage[];
  /** CMS header copy; each field falls back to the static copy when empty. */
  section?: PopularPackageSection;
}

export default function TourSlider({ packages, section }: TourSliderProps) {
  const subTitle = section?.subTitle || DEFAULT_SUB_TITLE;
  const title = section?.title || DEFAULT_TITLE;

  if (!packages || packages.length === 0) return null;

  return (
    <section
      className="tour-area position-relative bg-smoke overflow-hidden space"
      id="service-sec"
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-6 offset-lg-3">
            <div className="title-area text-center">
              <span className="sub-title">{subTitle}</span>
              <h2 className="sec-title">{title}</h2>
            </div>
          </div>
        </div>
        <div className="slider-area tour-slider">
          <Swiper
            className="th-slider has-shadow slider-drag-wrap"
            spaceBetween={10}
            breakpoints={{
              0: { slidesPerView: 1 },
              576: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              992: { slidesPerView: 2 },
              1200: { slidesPerView: 3 },
            }}
          >
            {packages.map((pack) => (
              <SwiperSlide key={pack.id}>
                <PackageCard pack={pack} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}
